import { Modality } from '@semanticedge/persistence-service-noheaders-client/src'

export const MODALITY_LABELS: Partial<Record<Modality, string>> = {
	[Modality.Chat]: 'Chat',
	[Modality.Voice]: 'Voice'
}
